import { RootState, TypedDispatch } from "../../../../redux/store";
import { connect } from "react-redux";
import { FeesInitialStateDTO } from "../service/types";
import { transactionList } from "../service/feesSlice";
import Fees from "../components/Fees";

interface StateProps extends FeesInitialStateDTO {}

interface DispatchProps {
  GetTransactionList(data: any): void;
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    success: state.fees.success,
    error: state.fees.error,
    loading: state.fees.loading,
    transactionData: state.fees.transactionData,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    GetTransactionList: (data: any) => {
      dispatch(transactionList(data));
    },
  };
};

export interface FeesProps extends StateProps, DispatchProps {}
export const FeesComponent = connect(mapStateToProps, mapDispatchToProps)(Fees);
